import { Fetching, IFetch } from './';

const Fetch = (): IFetch => {
  return new Fetching();
};

export default Fetch();
